import { useMemo, useState } from "react";
import { EditOutlined, MinusCircleOutlined, PlusOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { Button, Card, Select, Space, Tooltip, Form, Input, Modal, Tabs, Table, Row, Col } from "antd";
import PageHeader from "../../view/pageheader";
import TableComponent from "../CustomComponents/TableComponent";
import { Link, useNavigate, useParams, useSearchParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import dayjs from 'dayjs'
import { useEffect } from "react"
import SearchComponent from "../CustomComponents/SearchComponent";
import { getJobDashBoard, getJobBarcodeDashBoard, getAllBoxes } from '../../store/reducer/jobSlice';


const JobDashBoard = () => {
    const { getJobDashBoardData, getJobBarcodeDashBoardData, getAllBoxesData } = useSelector((state) => state.jobs);
    const { data: jobBarcodeData, total: count } = getJobBarcodeDashBoardData || {};
    // const { count: totalCount, data: tableData } = getAllBoxesData || {};

    const { eventDashboard, mainDashboard, eventNameMap, count: totalCount, data: tableData } = getJobDashBoardData
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const {
        job_name,
        customer_id,
        workflow_name,
        spec_id,
        workflow_id
    } = location.state || {};


    const [searchValue, setSearchValue] = useState("");
    function getData(payload = {}) {
        dispatch(getJobDashBoard({ id: window.atob(id) }))
        dispatch(getJobBarcodeDashBoard({ id: window.atob(id), ...payload }))
        dispatch(getAllBoxes({ job_spec_id: window.atob(id), ...payload }))
    }
    useEffect(() => {
        getData()
    }, [dispatch, id])

    const [eventIdMap, setEventIdMap] = useState({});

    useEffect(() => {
        if (eventNameMap) {
            const map = Object.fromEntries(
                Object.entries(eventNameMap).map(([id, name]) => [name, Number(id)])
            );
            setEventIdMap(map);
        }
    }, [eventNameMap]);


    // Final column order: total → event(s) → total completed
    const columns = [
        {
            title: "Total Boxes",
            dataIndex: 'total_boxes',
            key: 'total_boxes',
            align: 'center',
            render: (text, record) => (
                record?.total_boxes > 0 ? (
                    <span
                        style={{ fontWeight: 900, cursor: "pointer", color: "#1677ff" }}
                        onClick={() => handleNavigate(null)}
                    >
                        {record?.total_boxes}
                    </span>
                ) : (
                    <span style={{ fontWeight: 900 }}>{record?.total_boxes}</span>
                )
            )
        },
        {
            title: "New",
            dataIndex: 'new_boxes',
            key: 'new_boxes',
            align: 'center',
            render: (text, record) => (
                record?.new_boxes > 0 ? (
                    <span
                        style={{ cursor: "pointer", color: "#1677ff" }}
                        onClick={() => handleNavigate("New")}
                    >
                        {record?.new_boxes}
                    </span>
                ) : (
                    <span>{record?.new_boxes}</span>
                )
            )
        },
        {
            title: "Incomplete",
            dataIndex: 'Incomplete',
            key: 'Incomplete',
            align: 'center',
            render: (text, record) => (
                record?.InComplete > 0 ? (
                    <span
                        style={{ cursor: "pointer", color: "#1677ff" }}
                        onClick={() => handleNavigate("InComplete")}
                    >
                        {record?.InComplete}
                    </span>
                ) : (
                    <span>{record?.InComplete}</span>
                )
            )
        },
        {
            title: "Completed",
            dataIndex: 'completed_boxes',
            key: 'completed_boxes',
            align: 'center',
            render: (text, record) => (
                record?.completed_boxes > 0 ? (
                    <span
                        style={{ cursor: "pointer", color: "#1677ff" }}
                        onClick={() => handleNavigate("Completed")}
                    >
                        {record?.completed_boxes}
                    </span>
                ) : (
                    <span>{record?.completed_boxes}</span>
                )
            )
        },
        {
            title: "Disposition Completed",
            dataIndex: 'disposition_completed',
            key: 'disposition_completed',
            align: 'center',
            render: (text, record) => (
                record?.disposition_completed > 0 ? (
                    <span
                        style={{ cursor: "pointer", color: "#1677ff" }}
                        onClick={() => handleNavigate("Dispositon Completed")}
                    >
                        {record?.disposition_completed}
                    </span>
                ) : (
                    <span>{record?.disposition_completed}</span>
                )
            )
        },
        {
            title: "Re Assign Spec",
            dataIndex: 're_assign_spec',
            key: 're_assign_spec',
            align: 'center',
            render: (text, record) => (
                record?.reassign_spec > 0 ? (
                    <span
                        style={{ cursor: "pointer", color: "#1677ff" }}
                        onClick={() => handleNavigate("Re Assign Spec")}
                    >
                        {record?.reassign_spec}
                    </span>
                ) : (
                    <span>{record?.reassign_spec}</span>
                )
            )
        }
    ];

    const handleNavigate = (status) => {
        if (status) {
            navigate(`/all-boxes?status=${status}&job_spec_id=${id}`);
        } else {
            navigate(`/all-boxes?job_spec_id=${id}`);
        }
    };

    const box_columns = [
        {
            title: 'Barcode',
            dataIndex: 'barcode',
            key: 'barcode',
            align: 'center',
        },
        {
            title: 'Spec ID',
            dataIndex: 'spec_id',
            key: 'spec_id',
            align: 'center',
        },
        {
            title: 'Spec Box No',
            dataIndex: 'spec_box_number',
            key: 'spec_box_number',
            align: 'center',

        },

        {
            title: 'Stage',
            dataIndex: 'event_stage',
            key: 'event_stage',
            align: 'center',
            render: data => {
                if (data) {
                    return <span>{data}</span>
                } else {
                    return <span> Prep</span>
                }

            },
        },
        {
            title: 'Box Status',
            dataIndex: 'box_status',
            key: 'box_status',
            align: 'center',
            // render: (state) => {
            //     return state == 0 ? <span>New</span> : <span>Completed</span>;
            // }
        },

        {
            title: 'Pickup Date',
            dataIndex: 'pickup_date',
            key: 'pickup_date',
            align: 'center',
            render: (date) => {
                return date ? dayjs(date).format('MM/DD/YYYY') : 'Yet to update';
            }
        },
        {
            title: 'Box State',
            key: 'box_state',
            render: (_, record) => (
                <span
                    style={record.is_moved == 1 ? { color: 'red', fontWeight: 600 } : {}}
                >
                    {record.is_moved == 1
                        ? record?.box_state
                            ? `${record.box_state} - ${record.moved_spec || ''}`
                            : ''
                        : record?.box_state || ''}
                </span>


            ),
            align: 'center',
        },

        {
            title: 'Process Box',
            key: 'action',
            align: 'center',
            render: (_, record) => (
                <Space size="middle">
                    {/* <Button className="primary-btn rounded-4">View</Button> */}
                    <Button
                        disabled={record?.is_production == 0}
                        onClick={() => {
                            navigate(`/jobs/job_event/${window.btoa(record.job_spec_id)}`, {
                                state: {
                                    job_name: window.btoa(record.job_name),
                                    spec_id: record?.spec_id,
                                    job_barcode: record?.barcode,
                                    // workflow_name: workflow_name,
                                    customer_id: window.btoa(record?.user_id),
                                    // workflow_id: workflow_id

                                }
                            })
                        }}
                        icon={<ArrowRightOutlined />} className="primary-btn rounded-1"></Button>
                </Space>
            ),
        },
        {
            title: "Box Event History",
            key: "history",
            dataIndex: "history",
            align: 'center',
            render: (_text, record) => (
                <Button
                    shape="circle"
                    className="border-0"
                    icon={<ArrowRightOutlined />}
                    onClick={() =>
                        navigate(`/view-event-stages-history/${window.btoa(record.barcode)}`)
                    }
                />
            )
        },
    ]
    const generateEventStatusColumns = (data) => {
        if (!Array.isArray(data) || data.length === 0) return [];

        // Get all dynamic keys (event names) from the first row, excluding "status"
        const dynamicEventKeys = Object.keys(data[0]).filter(key => key !== "status");
        // Build columns array
        const columns = [
            {
                title: "Status",
                dataIndex: "status",
                key: "status",
                fixed: "left",
            },
            ...dynamicEventKeys.map((eventKey) => ({
                title: eventKey,         // use the event name as column title
                dataIndex: eventKey,     // access data by dynamic key
                key: eventKey,
                render: (text, record) => {
                    const dashboardType =
                        record.status === "Yet to start" ? 1 :
                            record.status === "In Progress" ? 2 :
                                record.status === "Completed" ? 3 : null;

                    if (text > 0) {
                        return (
                            <>
                                {dashboardType === 1 || dashboardType === 2 ? (
                                    <Link
                                        to={{
                                            pathname: `/jobs/job_event_details/${id}`,
                                        }}
                                        state={{
                                            job_name,
                                            spec_id,
                                            workflow_name,
                                            event_id: window.btoa(eventIdMap[eventKey]),
                                            customer_id,
                                            workflow_id,
                                            dashboardType,
                                        }}
                                    >
                                        {text}
                                    </Link>
                                ) : (
                                    <Link
                                        to={{
                                            pathname: `/jobs/job_event_completed/${id}`,
                                        }}
                                        state={{
                                            job_name,
                                            spec_id,
                                            workflow_name,
                                            customer_id,
                                            workflow_id,
                                            event_id: window.btoa(eventIdMap[eventKey]),
                                        }}
                                    >
                                        {text}
                                    </Link>
                                )}
                            </>
                        );
                    } else {
                        return <span>{text}</span>;
                    }
                },

                align: 'center'
            })),
        ];

        return columns;
    };
    const generateJobEventStatusColumns = (data) => {
        if (!Array.isArray(data) || data.length === 0) return [];

        // Get all dynamic keys (event names) from the first row, excluding "status"
        const dynamicEventKeys = Object.keys(data[0]).filter(key => key !== "barcode");

        // Build columns array
        const columns = [
            {
                title: "Box Number",
                dataIndex: "barcode",
                key: "barcode",
                fixed: "left",
                render: (text, record) => (
                    <Link
                        to={{
                            pathname: `/jobs/job_event/${id}`,
                        }}
                        state={{
                            job_name,
                            spec_id,
                            job_barcode: record.barcode,
                            workflow_name,
                            customer_id,
                            workflow_id,
                        }}
                    >
                        {record.barcode}
                    </Link>
                )
            },
            ...dynamicEventKeys.map((eventKey) => ({
                title: eventKey,         // use the event name as column title
                dataIndex: eventKey,     // access data by dynamic key
                key: eventKey,
                align: 'center'
            })),
            {
                title: "Box Event History",
                key: "history",
                dataIndex: "history",
                align: 'center',
                render: (_text, record) => (
                    <Button
                        shape="circle"
                        className="border-0"
                        icon={<ArrowRightOutlined />}
                        onClick={() =>
                            navigate(`/view-event-stages-history/${window.btoa(record.barcode)}`)
                        }
                    />
                )
            },
        ];

        return columns;
    };

    const handleSearchClick = () => {
        if (searchValue.trim() == "") {
            toast.error("Please enter a valid Box Number");
            return;

        }
        navigate(`/jobs/job_event/${id}`, {
            state: {
                job_name: job_name,
                spec_id: spec_id,
                job_barcode: searchValue,
                workflow_name: workflow_name,
                customer_id: customer_id,
                workflow_id: workflow_id

            }
        })

    };
    return (
        <div>
            <PageHeader HeaderText="Jobs" Breadcrumb={[{ name: "Jobs" }]} backgroundUrlName={true} />
            <Card
                title={`${window.atob(job_name)} - ${window.atob(spec_id)}`}
                extra={
                    <>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                // marginRight: '200px',
                            }}
                        >
                            <Space size={"large"}>
                                <SearchComponent
                                    style={{ width: '500px' }}
                                    placeHolder="Search Box Number"
                                    value={searchValue}
                                    onChange={e => {
                                        const val = e.target.value;
                                        setSearchValue(val);
                                        if (!val.trim()) {
                                            getData({});
                                        }
                                    }}
                                    onPressEnter={handleSearchClick}
                                />
                                <Button onClick={handleSearchClick} className='primary-btn rounded-4' >
                                    Search Box Number
                                </Button>
                            </Space>
                        </div>

                    </>
                }
            >
                <Table columns={columns} dataSource={Array.isArray(mainDashboard) ? mainDashboard : [mainDashboard]} pagination={false} size={"small"} />

                <Table style={{ marginTop: '40px' }} columns={generateEventStatusColumns(eventDashboard)} dataSource={Array.isArray(eventDashboard) ? eventDashboard : [eventDashboard]} pagination={false} size={"small"} />
                <TableComponent style={{ marginTop: '40px' }} columns={box_columns} dataSource={tableData} size={"small"} />
                {/* <Space size={"middle"} className="mt-4">

                    <SearchComponent
                        placeHolder="Search Box Number"
                        onChange={e => {
                            const payloadData = {
                                query: e.target.value,
                            };
                            getData(payloadData);
                        }} />


                </Space>
                <TableComponent style={{ marginTop: '10px' }} columns={generateJobEventStatusColumns(jobBarcodeData)} dataSource={jobBarcodeData} TotalDataCount={count} onChangeDispatch={getData} /> */}

            </Card>
            {/* {eventData && (
                <div style={{ marginTop: 20 }}>
                    <h6> Event - QC </h6>
                  
                    <Table
                        columns={[
                            { title: 'Box ID', dataIndex: 'box_id', key: 'box_id' },
                            { title: 'Alt Box', dataIndex: 'alt_box', key: 'alt_box' },
                            { title: 'Total', dataIndex: 'total', key: 'total' },
                        ]}
                        dataSource={[
                            { key: '1', box_id: 'BOX001', alt_box: 1, total: 20 },
                            { key: '2', box_id: 'BOX002', alt_box: 2, total: 40 },
                        ]}
                        pagination={false}
                        size="small"
                    />
                </div>
            )} */}
        </div>
    );
};

export default JobDashBoard;
